import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as queryString from 'query-string';

import SavedSearchSubscribeldBottom from '@components/SavedSearchSubscribeldBottom';
import { useFilterData } from '@hook/productFilters';
import { useCatalogRouteMatch } from '@utils/common';
import { logger } from '@utils/logger';

import { useHashFromCatalogUrlLazyQuery } from './queries/graphql.v3.generated';

// consts
const telegramUrl = 'https://telegram.me/ShafaUaSubscriberBot';

export const GetTelegramClickButton = () => {
  const { activeFilters } = useFilterData();
  const match = useCatalogRouteMatch();
  const [load, { data }] = useHashFromCatalogUrlLazyQuery();

  useEffect(() => {
    if (data?.searchSubscribeId) {
      window.location.href = `${telegramUrl}?start=${data?.searchSubscribeId}`;
    }
  }, [data]);

  useEffect(() => {
    if (!match) {
      logger.error('Save tg search: match is undefined');
    }
  }, [match]);

  if (!match) {
    return () => undefined;
  }

  return () => {
    let catalogUrl;
    if (match?.params?.indexedFilter) {
      const { params } = match;
      catalogUrl = `${[
        window.location.origin,
        params.namespace,
        'slug' in params ? params.slug : undefined,
      ].join('/')}?${queryString.stringify(activeFilters)}`;
    } else {
      catalogUrl = window.location.href;
    }

    return load({
      variables: {
        catalogUrl,
      },
    });
  };
};

export const useIsAutoSearch = () => {
  const { search } = useLocation();

  const params = new URLSearchParams(search);

  return !!params.get('isAutoSearch');
};

interface Props {
  className?: string,
}

export const SearchSubscribeTelegramContainer: React.FC<Props> = ({
  className,
}) => {
  const click = GetTelegramClickButton();
  const isAutoSearch = useIsAutoSearch();
  if (isAutoSearch) {
    return null;
  }

  return (
    <SavedSearchSubscribeldBottom
      className={className}
      onTelegramClick={click}
    />
  );
};

export default SearchSubscribeTelegramContainer;
